import router from '../router'
import VueTk from '@moke/vue-tk'
import store from '@/store'
const rulers = [{
  match: '*',
  except: [
    '/user/login',
    '/exception/403',
    '/exception/404'
  ],
  handler: async function (route, next) {
    if (store.state.sessionToken) {
      // 判断路由是否有权访问
      next(true)
    } else {
      next('/user/login')
    }
  },
  fallbackUrl: '/exception/403'
}]

VueTk.tkRouterAuth.init(rulers, router)
